import { render, staticRenderFns } from "./Migration.vue?vue&type=template&id=42c6a0e3&"
import script from "./Migration.vue?vue&type=script&lang=js&"
export * from "./Migration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports